import { formatSignupInput } from '@jetshop/core/components/Auth/formatSignupInput';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import SignupMutation from '@jetshop/core/data/mutations/signup.gql';
import getErrorDetail from '@jetshop/core/helpers/getErrorDetail';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { useContext } from 'react';
import { SignupContext } from './signup-context';
import { trackRegisterEvent } from '../../analytics/tracking';
import { useTracker } from '../../analytics/Analytics';
export function useSignupSubmit() {
    const [mutate] = useMutation(SignupMutation);
    const client = useApolloClient();
    const { logIn } = useAuth();
    const { isUserTypeBusiness } = useContext(SignupContext);
    const track = useTracker();
    return function signup({ values, actions }) {
        // Set the Formik state to submitting…
        actions.setSubmitting(true);
        mutate({
            variables: {
                input: formatSignupInput(values, {
                    userType: isUserTypeBusiness ? 'COMPANY' : 'PRIVATE'
                })
            }
        })
            .then(resp => {
            // Submitting is done
            actions.setSubmitting(false);
            // Track user register in GTAG
            track(trackRegisterEvent());
            // Reset the Apollo store
            client.resetStore().then(() => {
                // Log the user in with the token from signup
                logIn(resp.data.signUp.token.value);
            });
        }, error => {
            const errorDetail = getErrorDetail(error);
            const validationDetails = getvalidationDetails(errorDetail);
            // Submitting is done
            actions.setSubmitting(false);
            actions.setStatus({
                validationDetails,
                isSignupError: true
            });
        })
            .catch(err => {
            console.log(err);
            actions.setSubmitting(false);
        });
    };
}
function getvalidationDetails(errorDetail) {
    const [field] = Object.keys(errorDetail.data[0]);
    const [detail] = errorDetail.data[0][field];
    return [field, detail];
}
//# sourceMappingURL=signupSubmit.js.map